'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _productNav = require('./productNav');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_productNav).default;
  }
});

var _model = require('./model');

Object.defineProperty(exports, 'ProductListType', {
  enumerable: true,
  get: function get() {
    return _model.ProductListType;
  }
});
Object.defineProperty(exports, 'ProductRecordType', {
  enumerable: true,
  get: function get() {
    return _model.ProductRecordType;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/product-nav/index.js
// module id = 452
// module chunks = 0